type Props = {
  color?: string;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
};

/**
 * Tileable mid-century breeze-block pattern. Drop it as a decorative band
 * behind a section — keep opacity low so it stays a backdrop.
 */
export default function BreezeBlock({
  color = "var(--c-palm)",
  size = 56,
  className,
  style,
}: Props) {
  const patternId = "breeze-block-pattern";
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="100%"
      height="100%"
      className={className}
      style={style}
    >
      <defs>
        <pattern
          id={patternId}
          x="0"
          y="0"
          width={size}
          height={size}
          patternUnits="userSpaceOnUse"
        >
          <rect width={size} height={size} fill="none" />
          <g
            fill="none"
            stroke={color}
            strokeWidth="1.4"
            strokeLinecap="round"
          >
            <circle cx={size / 2} cy={size / 2} r={size / 2 - 4} />
            <line x1="0" y1={size / 2} x2={size} y2={size / 2} />
            <line x1={size / 2} y1="0" x2={size / 2} y2={size} />
            <line x1="0" y1="0" x2={size} y2={size} />
            <line x1={size} y1="0" x2="0" y2={size} />
          </g>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${patternId})`} />
    </svg>
  );
}
